module.exports = __webpack_public_path__ + "images/private-dick-47869a097891a5bf7b147f569f5a1559.png";